import React, { Component } from "react";
import {withTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import * as RestService from '../../services/eisRest';
 

class UploadImage extends Component {
  constructor(props) {
    super(props);
    this.selectFile = this.selectFile.bind(this);
    this.upload = this.upload.bind(this);
    
    this.state = {
      currentFile: undefined,
      previewImage: undefined,
      progress: 0,
      message: "",      
      imageInfos: [],
      cardActive: this.props.cardActive
    };
  }

 
 getFile () {  
    RestService.callAnyApi('file/getFile?id='+this.props.fileId, '[]')
    .then((data) => {                                     
            try{
              this.setState({
                message: data  
              });
            }catch(error){
                console.error();
            }
           
    })
    .catch((error) => {               
        toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
                'Failed'
        );
    });


  }

  componentDidUpdate(prevProps, prevState) {
    
     // this.getFile();
    if (prevProps.cardActive != this.props.cardActive) {
      this.getFile();
    }
  }

  componentDidMount() {
    this.getFile();
  }

  selectFile(event) {
    this.setState({
      currentFile: event.target.files[0],
      previewImage: URL.createObjectURL(event.target.files[0]),
      progress: 0,
      message: ""
    });
  }

  upload() {
    this.setState({
      progress: 0,
    });

    RestService.uploadFile(this.state.currentFile, (event) => {
      this.setState({
        progress: Math.round((100 * event.loaded) / event.total),
      });
    },this.props.fileId,this.props.entityId,this.props.description)
      .then((response) => {
        this.setState({
          message: response.data.message,
        });
        return RestService.getFile(this.props.fileId);
      })
      .then((files) => {
        this.setState({
          imageInfos: files.data,
        });
      })
      .catch((err) => {
        this.setState({
          progress: 0,
          message: "Could not upload the image!",
          currentFile: undefined,
        });
      });
  }

  render() {
    const {
      currentFile,
      previewImage,
      progress,
      message,
      imageInfos,
    } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-8">
            <label className="btn btn-default p-0">
              <input type="file" accept="image/png" onChange={this.selectFile} />
            </label>
          </div>

          <div className="col-4">
            <button
              className="btn btn-success btn-sm"
              disabled={!currentFile}
              onClick={this.upload}
            >
              {this.props.t('general.button.upload'+this.props.description)}
            </button>
          </div>
        </div>

        {currentFile && (
          <div className="progress my-3">
            <div
              className="progress-bar progress-bar-info progress-bar-striped"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: progress + "%" }}
            >
              {progress}%
            </div>
          </div>
        )}

         <div>{this.props.t('general.label.preview')}</div>
        {previewImage && (
          <div>
            <img className="preview" src={previewImage} alt="" />
          </div>
        )}

          <div>{this.props.t('general.label.saved')} {this.props.description}</div>
          <div>           
            <img className="preview" src={`data:image/png;base64,${message}` || '/img/no_image.png'} alt="" />
          </div> 

    
      </div>
    );
  }
}

export default withTranslation()(UploadImage);